// CRA chỉ thay thế ổn định khi biến được truy cập trực tiếp theo cú pháp bên dưới.
const BUILD_BACKEND_URL = process.env.REACT_APP_PUBLIC_BACKEND_URL;

// Ưu tiên runtime config, sau đó dùng giá trị được đóng vào bundle lúc build.
export function getBackendUrl() {
  const runtimeBackendUrl =
    typeof window !== "undefined"
      ? window.__ENV__?.REACT_APP_PUBLIC_BACKEND_URL ||
        window.__ENV__?.PUBLIC_BACKEND_URL
      : undefined;
  const backendUrl = runtimeBackendUrl || BUILD_BACKEND_URL;

  if (!backendUrl) {
    throw new Error(
      "Missing REACT_APP_PUBLIC_BACKEND_URL. Restart the dev server after updating the env file.",
    );
  }

  return backendUrl.replace(/\/+$/, "");
}
